import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Button } from "pepsico-ds";
import PropTypes from "prop-types";

const CONDITION_TYPES = [
  {
    key: "survey",
    label: "Survey",
    description: "User has to answer a question",
  },
  {
    key: "storeGroup",
    label: "Store group",
    description: "User has to select a single store or multiple of stores",
  },
  {
    key: "retailer",
    label: "Retailer",
    description: "User has to select a single retailer or multiple retailers",
  },
];

export default function ConditionTypeSelector({
  selectedType,
  onTypeSelect,
  onContinue,
  onCancel,
  enabledTypes,
}) {
  return (
    <div className="condition-type-selector" data-testid="condition-type-selector">
      <DialogTitle className="condition-type-selector__header">
        <span>Add condition</span>
        <IconButton aria-label="Close" onClick={onCancel} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <p className="condition-type-selector__subtitle">
          Select conditional type to continue
        </p>
        <div className="condition-type-selector__grid">
          {CONDITION_TYPES.map(({ key, label, description }) => {
            const enabled = !!enabledTypes[key];
            return (
              <button
                key={key}
                type="button"
                data-testid={`condition-type-${key}`}
                className={`condition-type-selector__card${
                  selectedType === key
                    ? " condition-type-selector__card--selected"
                    : ""
                }${!enabled ? " condition-type-selector__card--disabled" : ""}`}
                onClick={enabled ? () => onTypeSelect(key) : undefined}
                disabled={!enabled}
              >
                <span className="condition-type-selector__card-label">{label}</span>
                <span className="condition-type-selector__card-description">
                  {description}
                </span>
              </button>
            );
          })}
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="tertiary" text="Cancel" size="medium" onClick={onCancel} />
        <Button
          variant="primary"
          text="Next"
          size="medium"
          onClick={onContinue}
          disabled={!selectedType}
        />
      </DialogActions>
    </div>
  );
}

ConditionTypeSelector.propTypes = {
  selectedType: PropTypes.string,
  onTypeSelect: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  // Which condition-type cards are selectable. Callers enable a type only when the
  // outcome actually supports it (e.g. storeGroup when it carries the
  // retailer-matching-rule). Unlisted types default to disabled.
  enabledTypes: PropTypes.objectOf(PropTypes.bool),
};

ConditionTypeSelector.defaultProps = {
  selectedType: null,
  enabledTypes: { survey: true, storeGroup: false, retailer: false },
};
